"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.overrides = void 0;
var material_1 = require("@mui/material");
exports.overrides = {
    MuiCheckbox: {
        styleOverrides: {
            root: function (_a) {
                var _b;
                var theme = _a.theme;
                return (_b = {
                        fontSize: '0.94rem',
                        color: "var(--neutrals-800, ".concat(theme.palette.neutrals.tertiary, ")")
                    },
                    _b["&.".concat(material_1.checkboxClasses.checked)] = {
                        color: "var(--secondary-500, ".concat(theme.palette.secondary.main, ")"),
                    },
                    _b["&.".concat(material_1.checkboxClasses.indeterminate)] = {
                        color: "var(--secondary-500, ".concat(theme.palette.secondary.main, ")"),
                    },
                    _b["&.".concat(material_1.checkboxClasses.disabled)] = {
                        color: "var(--text-disabled, ".concat(theme.palette.text.disabled, ")"),
                    },
                    _b);
            },
        },
    },
    MuiRadio: {
        styleOverrides: {
            root: function (_a) {
                var _b;
                var theme = _a.theme;
                return (_b = {
                        color: "var(--neutrals-800, ".concat(theme.palette.neutrals.tertiary, ")")
                    },
                    _b["&.".concat(material_1.radioClasses.checked)] = {
                        color: "var(--secondary-500, ".concat(theme.palette.secondary.main, ")"),
                    },
                    _b);
            },
        },
    },
    MuiOutlinedInput: {
        styleOverrides: {
            notchedOutline: function (_a) {
                var theme = _a.theme;
                return ({
                    borderColor: "var(--neutrals-700, ".concat(theme.palette.neutrals.disabled, ")"),
                });
            },
            input: function (_a) {
                var theme = _a.theme;
                return ({ color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") });
            },
            root: function (_a) {
                var _b, _c;
                var theme = _a.theme;
                return (_b = {},
                    _b["&:hover .".concat(material_1.outlinedInputClasses.notchedOutline)] = {
                        borderColor: "var(--text-primary, ".concat(theme.palette.text.primary, ")"),
                    },
                    // Reset on touch devices
                    _b['@media (hover: none)'] = (_c = {},
                        _c["&:hover .".concat(material_1.outlinedInputClasses.notchedOutline)] = {
                            borderColor: "var(--neutrals-700, ".concat(theme.palette.neutrals.disabled, ")"),
                        },
                        _c),
                    _b["&.".concat(material_1.outlinedInputClasses.focused, " .").concat(material_1.outlinedInputClasses.notchedOutline)] = {
                        borderColor: "var(--secondary-500, ".concat(theme.palette.secondary.main, ")"),
                    },
                    _b["&.".concat(material_1.outlinedInputClasses.error, " .").concat(material_1.outlinedInputClasses.notchedOutline)] = {
                        borderColor: "var(--error-700, ".concat(theme.palette.error.dark, ")"),
                    },
                    _b["&.".concat(material_1.outlinedInputClasses.disabled, " .").concat(material_1.outlinedInputClasses.notchedOutline)] = {
                        borderColor: "var(--neutrals-300, ".concat(theme.palette.neutrals.primary, ")"),
                    },
                    _b);
            },
        },
    },
    MuiTooltip: {
        styleOverrides: {
            tooltip: function (_a) {
                var _b, _c;
                var theme = _a.theme, ownerState = _a.ownerState;
                var commonStyles = {
                    padding: '0.5rem',
                    boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.2), 0px 3px 4px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.14)',
                };
                if (((_c = (_b = ownerState === null || ownerState === void 0 ? void 0 : ownerState.componentsProps) === null || _b === void 0 ? void 0 : _b.tooltip) === null || _c === void 0 ? void 0 : _c.variant) === 'light') {
                    return __assign(__assign({}, commonStyles), { borderRadius: '0.5rem', color: "var(--text-tertiary, ".concat(theme.palette.text.tertiary, ")"), background: "var(--background-white, ".concat(theme.palette.backgrounds.white, ")"), border: "1px solid var(--neutrals-300, ".concat(theme.palette.neutrals.primary, ")") });
                }
                return commonStyles;
            },
            arrow: function (_a) {
                var _b, _c;
                var theme = _a.theme, ownerState = _a.ownerState;
                if (((_c = (_b = ownerState === null || ownerState === void 0 ? void 0 : ownerState.componentsProps) === null || _b === void 0 ? void 0 : _b.tooltip) === null || _c === void 0 ? void 0 : _c.variant) === 'light') {
                    return {
                        '&::before': {
                            background: "var(--background-white, ".concat(theme.palette.backgrounds.white, ")"),
                        },
                    };
                }
            },
        },
    },
    MuiLinearProgress: {
        styleOverrides: {
            root: function (_a) {
                var _b;
                var theme = _a.theme;
                return (_b = {},
                    _b["&.".concat(material_1.linearProgressClasses.determinate)] = {
                        backgroundColor: "var(--neutral-300, ".concat(theme.palette.neutrals.primary, ")"),
                    },
                    _b["&.".concat(material_1.linearProgressClasses.indeterminate)] = {
                        backgroundColor: "var(--neutral-300, ".concat(theme.palette.neutrals.primary, ")"),
                    },
                    _b);
            },
            bar: function (_a) {
                var theme = _a.theme, ownerState = _a.ownerState;
                return (__assign(__assign(__assign({}, (ownerState.color === 'primary' && {
                    backgroundColor: "var(--secondary-500, ".concat(theme.palette.secondary.main, ")"),
                })), (ownerState.color === 'success' && {
                    backgroundColor: "var(--success-700, ".concat(theme.palette.success.dark, ")"),
                })), (ownerState.color === 'error' && {
                    backgroundColor: "var(--error-700, ".concat(theme.palette.error.dark, ")"),
                })));
            },
        },
    },
    MuiAccordion: {
        styleOverrides: {
            root: function (_a) {
                var _b;
                var theme = _a.theme, ownerState = _a.ownerState;
                var commonStyles = (_b = {},
                    // place the ExpandMoreIcon on the left
                    _b["& .".concat(material_1.accordionSummaryClasses.root)] = {
                        flexDirection: 'row-reverse',
                    },
                    _b["& .".concat(material_1.accordionSummaryClasses.expandIconWrapper)] = {
                        color: "var(--secondary-500, ".concat(theme.palette.secondary.main, ")"),
                    },
                    _b["& .".concat(material_1.accordionSummaryClasses.content)] = {
                        paddingLeft: '0.5rem',
                    },
                    _b);
                if ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.variant) === 'darkFlat' || (ownerState === null || ownerState === void 0 ? void 0 : ownerState.variant) === 'whiteFlat') {
                    return __assign(__assign({}, commonStyles), { border: 'none' });
                }
                return commonStyles;
            },
        },
    },
};
